<template>
  <div id="project">
    <!-- First -->
    <div id="firstPart">
      <p id="title">
        {{ currentProject.title }}
      </p>
      <div id="firstSubLine">
        <p class="firstPartText">
          {{ currentProject.date }}
        </p>
        <p class="firstPartText" id="work">
          {{ currentProject.work }}
        </p>
      </div>
    </div>
    <!-- Visit -->
    <div id="visitWrap" :style="{ 'margin-top': marginTop + 'px' }">
      <a :href="currentProject.page_link" target="_blank">
        <button id="visitButton">
          VISIT<br>THE<br>WEBSITE
        </button>
      </a>
      <div id="mentionWrap">
        <div v-for="mention of currentProject.mentions" :key="mention" class="mentionLine">
          <p v-if="mention.sub">
            {{ mention.sub }}
          </p>
          <template v-for="(person, id) of mention.who" :key="id">
            <a :href="person.link" target="_blank" class="mentionLink">
              {{ person.name }}
            </a>
            <div v-if="id < mention.who.length - 1" class="spacer">
              X
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- Galery -->
    <div v-for="image of currentProject.images" :key="image" class="galeryWrap" :style="{ 'margin-top': marginTop + 'px' }">
      <div class="imageHolder">
        <img :src="require(`../assets/projects_images/${image.path}`)">
      </div>
      <p class="galeryTitle">
        {{ currentProject.id }}{{ image.description }}
      </p>
    </div>
    <!-- Back -->
    <div id="backWrap">
      <button id="backButton" class="underLineB" @click="$emit('backToNavigation')">
        <div id="arrowLeft">
          <img :src="require('../assets/assets2D/arrow-left.png')">
        </div>
        BACK
      </button>
    </div>
    <div id="stateBar" :style="{width:`${horizontalPosition}px`}">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Project',
  props: {
    currentProject: Object,
    sizes: Object,
    horizontalPosition: Number
  },
  data(){
    return {
      marginTop: 0
    }
  },
  methods: {
    measureText(str, fontSize) {
      const widths = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.2796875,0.2765625,0.3546875,0.5546875,0.5546875,0.8890625,0.665625,0.190625,0.3328125,0.3328125,0.3890625,0.5828125,0.2765625,0.3328125,0.2765625,0.3015625,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.2765625,0.2765625,0.584375,0.5828125,0.584375,0.5546875,1.0140625,0.665625,0.665625,0.721875,0.721875,0.665625,0.609375,0.7765625,0.721875,0.2765625,0.5,0.665625,0.5546875,0.8328125,0.721875,0.7765625,0.665625,0.7765625,0.721875,0.665625,0.609375,0.721875,0.665625,0.94375,0.665625,0.665625,0.609375,0.2765625,0.3546875,0.2765625,0.4765625,0.5546875,0.3328125,0.5546875,0.5546875,0.5,0.5546875,0.5546875,0.2765625,0.5546875,0.5546875,0.221875,0.240625,0.5,0.221875,0.8328125,0.5546875,0.5546875,0.5546875,0.5546875,0.3328125,0.5,0.2765625,0.5546875,0.5,0.721875,0.5,0.5,0.5,0.3546875,0.259375,0.353125,0.5890625]
      const avg = 0.5279276315789471
      return str
        .split('')
        .map(c => c.charCodeAt(0) < widths.length ? widths[c.charCodeAt(0)] : avg)
        .reduce((cur, acc) => acc + cur) * fontSize
    },
    setSizes(){
      const fontSize = this.measureText(this.currentProject.title, this.sizes.width * 0.01)
      document.getElementById('title').style.fontSize = `${this.sizes.width / fontSize}vw`
      document.getElementById('title').style.height = `${(this.sizes.width / fontSize) * 0.8}vw`
      
      const exploreBody = document.getElementById('exploreButton').getBoundingClientRect()
      document.getElementById('backWrap').style.marginTop = `${exploreBody.top - (this.sizes.height * (this.sizes.landscape ? 0.03 : 0.015))}px`

      const bodyHeight = document.body.getBoundingClientRect().height
      this.marginTop = this.sizes.landscape ?
          bodyHeight * 0.25 : 
          (bodyHeight * 0.5) - (this.sizes.width * 0.4)
    },
  },
  mounted(){
    this.$nextTick(() => {
      this.setSizes()
    })
  }
}
</script>

<style scoped>
#project
{
  position: relative;
  display: flex;
  flex-direction: row;
}
#title
{
  width: 100vw;
  text-align: center;
  margin: 0;
}
/* FIRST PART */
#firstPart
{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.firstPartText
{
  margin: 0;
}
#firstSubLine
{
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
/* VISIT */
#visitButton
{
  font-size: 5vh;

  border: 2px solid #111111;
  background-color: transparent;

  cursor: pointer;
  transition-timing-function:  ease-out;

  transition-duration: 250ms;
}
#visitButton:hover
{
  background-color: #111111;
  color: #F5F5F5;
}
/* MENTIONS */
.mentionLine
{
  margin-top: 0.5vh;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.mentionLine p
{
  margin: 0;
  margin-right: 0.5em;
  white-space: nowrap;
}
.mentionLink
{
  text-decoration: underline;
  color: #111111;
}
.spacer
{
  margin: 0 0.5em;
}
/* Galery */
.galeryTitle
{  
  text-align: right;

  margin: 0;
  margin-top: 0.5vh;
} 
#backButton
{
  white-space: nowrap;
  height: min-content;
  font-size: 1.5vh;
  padding: 0;
  z-index: 2;
  
  background-color: transparent;

  display: flex;
  cursor: pointer;
}
#backWrap
{
  position: sticky;
  right: 0;
  height: min-content;
}
#arrowLeft
{
  height: 1.5vh;
  width: 1.5vh;
  margin-right: 1vh;
  transition-duration: 250ms;
}
/* Images */
.imageHolder img,
#arrowLeft img
{
  height: 100%;
  width: 100%;
  object-fit: contain;
  pointer-events: none;
}
#stateBar
{
  position: fixed;
  top: 0;
  left: 0;

  height: 4px;
  background-color: #111111;
}
@media (orientation: landscape) {  
  #visitButton,
  .imageHolder
  {
    width: 50vh;
    height: 50vh;
  }
  .galeryTitle
  {
    width: 50vh;
  }
  .galeryWrap
  {
    margin-right: 25vh;
  }
  #visitWrap
  {
    margin: 0 25vh;
  }
  #backWrap
  {
    padding: 3vh;
  }
  .galeryTitle,
  .mentionLine *,
  .firstPartText  
  {
    font-size: 1.5vh;
  }
  .firstPartText
  {
    max-width: 25%;
  }
}
@media (orientation: portrait) {
  #title
  {
    margin-top:  10vh;
  }
  #visitButton,
  .imageHolder
  {
    width: 80vw;
    height: 80vw;
  }
  .mentionLine
  {
    max-width: 80vw;
  }
  .galeryTitle
  {
    width: 80vw;
  }
  .galeryWrap
  {
    margin-right: 25vw;
  }
  #visitWrap
  {
    margin: 0 25vw;
  }
  #backWrap
  {
    padding: 1.5vh;
  }
  .galeryTitle,
  .mentionLine *,
  .firstPartText  
  {
    font-size: 3vw;
  }
  .firstPartText
  {
    max-width: 50%;
  }
}
</style>
